export const UPDATED_WINDOW_SIZE = 'UPDATED_WINDOW_SIZE';
export const UPDATE_WINDOW_SIZE_WATCH_BEGIN = 'UPDATE_WINDOW_SIZE_WATCH_BEGIN';
export const UPDATE_WINDOW_SIZE_WATCH_END = 'UPDATE_WINDOW_SIZE_WATCH_END';

let windowSizeDispatch = null;

export const updateWindowSizeBegin = () => (dispatch) => {
	windowSizeDispatch = () => {
		dispatch(windowSizeChanged());
	};
	window.addEventListener('resize', windowSizeDispatch);
	dispatch(windowSizeChanged());
};

export const getWindowSizeValues = () => {
	const width = window.innerWidth;
	const sizeMobile = width <= 600;
	const sizeTablet = width > 600;
	const sizeDesktop = width > 992;
	const sizeLargeDesktop = width > 1200;
	return {
		screenHeight: window.innerHeight,
		screenWidth: width,
		sizeMobile,
		sizeTablet,
		sizeDesktop,
		sizeLargeDesktop
	};
};

const windowSizeChanged = () => {
	return {
		type: UPDATED_WINDOW_SIZE,
		payload: { ...getWindowSizeValues() }
	};
};

export const updateWindowSizeEnd = () => (dispatch) => {
	window.removeEventListener('resize', windowSizeDispatch);
};